/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 */

import { getItemFromSessionStorage, makeRequest } from '../../helpers';

export const postDeviceQuote = async (deviceQuoteData, cognitoAccessTokenKey, props = {}) => {
  const authToken = getItemFromSessionStorage(cognitoAccessTokenKey) || '';
  const basePath = process.env.REACT_APP_API_ENDPOINT || '/';
  return await makeRequest({
    method: 'POST',
    url: `${basePath}/device/device_quotes`,
    authToken: authToken,
    payload: deviceQuoteData,
    history: props.history
  });
};
